<template>
    <el-dialog title="赠送抽奖" :visible.sync="showModal" width="320px" :close-on-click-modal="false"
        :destroy-on-close="true">
        <el-form ref="form" :model="form" :rules="rules">
            <el-form-item prop="num">
                <el-input v-model.number="form.num" placeholder="赠送次数"></el-input>
            </el-form-item>
            <div>
                <el-button type="primary" @click="onSubmit('form')">提交</el-button>
                <el-button @click="trunOff">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>

<script>
import { user } from "@/api/userManagement"

export default {
    data: () => ({
        rules: {
            num: [
                { type: "number", required: true, message: '请输入抽奖次数', trigger: 'blur' },
            ]
        },
        form: {
            user_id: null,
            num: ''
        }
    }),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 用户ID
        userID: null | String
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        onSubmit(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    try {
                        user.pointCompensation(this.form)
                        this.$message({
                            message: "已赠送抽奖!",
                            type: 'success'
                        });
                        this.$emit("onUpdate")
                        this.trunOff()
                    } catch {
                        this.$message.error('出错了!');
                    }
                }
            });
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        },
    },
    created() {
        this.form.user_id = this.userID
    }
}
</script>

<style lang="scss" scoped>

</style>